const PREFERENCE_KEY_MAP = {
  PROGRAM_OVERVIEW: "program_overview",
} as const;

type PreferenceKeyName = keyof typeof PREFERENCE_KEY_MAP;
export type PreferenceKey = (typeof PREFERENCE_KEY_MAP)[PreferenceKeyName];

const _seen = new Set<string>();
const _keys = Object.keys(PREFERENCE_KEY_MAP) as PreferenceKeyName[];
for (let i = 0; i < _keys.length; i++) {
  const v = PREFERENCE_KEY_MAP[_keys[i]];
  if (_seen.has(v)) {
    throw new Error(`Duplicate PreferenceKey value "${v}" for key "${_keys[i]}"`);
  }
  _seen.add(v);
}

export const PreferenceKeys: Readonly<typeof PREFERENCE_KEY_MAP> = PREFERENCE_KEY_MAP;

const constants = {
  SESSION_EXPIRED: 'session_expired',
  SESSION_WILL_EXPIRE: 'session_will_expire',
  SESSION_TIMER_INTERVAL: 30000,
  
  // Authentication providers
  AUTH_PROVIDER_AMAZON: 'AmazonFederate',
  AUTH_PROVIDER_LASSO: 'LASSO',
  // IdPrism is an additional Federate OIDC IdP added for the LASSO->IdPrism
  // migration (P504206896). The shared auth library supports it natively as a
  // Cognito federated provider; selecting it is a matter of setting
  // AUTH_PROVIDER to this value in the stage config.
  AUTH_PROVIDER_IDPRISM: 'IdpPrism',
};

export default constants;
